import * as React from 'react';

import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { AppContext, AppConsumer } from '../../AppProvider';
import classnames from 'classnames';
import _get from 'lodash/get';

import Routes from '../routes';
import Sidebar from '../sidebar';
import SearchBar from '../Global/SearchBar';
import Eula from '../eula/Eula';

const styles = theme => ({
  root: {
    display: 'flex'
  },
  content: {
    flexGrow: 1,
    overflow: 'hidden'
  },
  contentBody: {
    position: 'relative',
    minHeight: '100vh'
  },
  paddingContentBody: {
    paddingTop: theme.spacing.unit * 5,
    paddingLeft: theme.spacing.unit * 5,
    paddingRight: theme.spacing.unit * 6,
    paddingBottom: theme.spacing.unit * 8.5
  }
});

export class Layout extends React.Component {
  render() {
    const { props } = this;
    const { auth, classes } = props;

    if (auth.isAuthenticated()) {
      const { eulaAccepted, orgInfo } = this.context.globalProps;
      const orgRequiresEula = _get(
        orgInfo,
        'config.orgUsersMustAcceptEula',
        false
      );
      const showEula = !eulaAccepted && orgRequiresEula;

      return (
        <AppConsumer>
          {({ showSearchbar, showSidebar }) => (
            <div className={classes.root}>
              <Sidebar auth={auth} />
              <main className={classes.content}>
                {<SearchBar auth={auth} />}
                <div
                  className={classnames(classes.contentBody, {
                    [classes.paddingContentBody]: showSearchbar && showSidebar
                  })}
                >
                  {showEula ? <Eula auth={auth} /> : <Routes auth={auth} />}
                </div>
              </main>
            </div>
          )}
        </AppConsumer>
      );
    }

    return <Routes auth={auth} />;
  }
}

Layout.contextType = AppContext;
const translatedLayout = withNamespaces()(Layout);
export default withStyles(styles, { withTheme: true })(translatedLayout);
